import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledAlert,
  Table,
} from "reactstrap";
import axios from "axios";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from "react-router-dom";
import { get } from "lodash";
import { getMalwareScanData } from "common/data/demo/reports";

// Function to fetch malware analysis results
const fetchScanResults = async (userId, scanId) => {
  try {
    const response = await axios.get(`https://api.compliance.cx/malware-scan/${userId}//${scanId}`);
    return response.data; // Return the scan results
  } catch (error) {
    if(userId === "demo") {
      return getMalwareScanData(scanId);
    }
    console.error("Error fetching scan results:", error);
    throw error;
  }
};

const MalwareAnalysisResults = () => {
  // meta title
  document.title = "Malware Analysis Results";
  const { scanId } = useParams();
  const [scanName, setScanName] = useState("");
  const [analysisData, setAnalysisData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const userId = obj.username;

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const jsonData = await fetchScanResults(userId, scanId);
        setScanName(jsonData.assetname); // Set asset name from the response
        setAnalysisData(jsonData.analysisReport); // Set the analysis report
        setLoading(false);
      } catch (err) {
        setError("Analysis in Progress");
        setLoading(false);
      }
    };
    fetchResults();
  }, [userId, scanId]);

  // Show alert if there's an error or loading
  const renderAlert = () => {
    if (error) {
      return (
        <UncontrolledAlert color="info" className="mt-3">
          {error}
        </UncontrolledAlert>
      );
    } else if (loading) {
      return (
        <UncontrolledAlert color="success" className="mt-3">
          Loading analysis results...
        </UncontrolledAlert>
      );
    }
  };

  // Table columns for displaying the analysis results
  const columns = [
    {
      Header: "Engine Name",
      accessor: "engine_name",
    },
    {
      Header: "Engine Version",
      accessor: "engine_version",
    },
    {
      Header: "Engine Update",
      accessor: "engine_update",
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Result",
      accessor: "result",
    },
  ];

  // Convert analysis report into an array format to be used by the table
  const analysisRows = Object.keys(analysisData).map((key) => {
    const engine = analysisData[key];
    return {
      engine_name: engine.engine_name,
      method: engine.method,
      engine_version: engine.engine_version,
      engine_update: engine.engine_update,
      category: engine.category,
      result: engine.result ? engine.result : "Not Detected",
    };
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={scanName} breadcrumbItem={scanId} />

          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="card-title">Malware Analysis Results</h4>
                    <Button color="primary">Export Results</Button>
                  </div>
                  <p className="text-muted">Scan Date: {new Date().toLocaleDateString()}</p>

                  {renderAlert()}

                  {/* Table for displaying results */}
                  <Card>
                    <CardBody>
                      <h5 className="font-weight-semibold">Malware Analysis Report</h5>
                      <Table hover responsive>
                        <thead>
                          <tr>
                            {columns.map((column) => (
                              <th key={column.accessor}>{column.Header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {analysisRows.length === 0 ? (
                            <tr>
                              <td colSpan={columns.length} className="text-center">
                                No analysis results available.
                              </td>
                            </tr>
                          ) : (
                            analysisRows.map((row, index) => (
                              <tr key={index}>
                                {columns.map((column) => (
                                  <td key={column.accessor}>{row[column.accessor]}</td>
                                ))}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MalwareAnalysisResults;
